<template>
    <v-container>
        <v-carousel cycle hide-delimiter-background height="200">
            <v-carousel-item
                    v-for="(item, i) in rotateImages"
                    :key="i"
                    :src="item.src"
                    reverse-tr0ansition="fade-transition"
                    transition="fade-transition">
            </v-carousel-item>
        </v-carousel>
        <v-row>
            <v-col>
                <h1>
                    gofiqr styrker din produktinformation,<br>
                    interne vidensdeling og profilering
                </h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                Med QR koder og gofiqr-universet giver du mennesker i dit liv let adgang til<br>
                informationer, procedurer og oplevelser
            </v-col>
        </v-row>
        <v-divider/>
        <v-row>
            <v-col xs="12" sm="12" md="4" v-for="(usage, i) in usages" :key="i">
                <v-card flat link :to="usage.path">
                    <v-img :src="usage.img" max-width="300" aspect-ratio="1" contain/>
                </v-card>
                <h2>{{ usage.title }}</h2>
                <div>{{ usage.text }}</div>
            </v-col>
        </v-row>
        <v-divider/>
        <v-row>
            <v-col>
                <v-img :src="require('@/assets/gofiqr-del-din-viden.png')"/>
            </v-col>
        </v-row>
        <v-divider/>
        <FourSimpleSteps/>
        <v-divider/>
        <v-row>
            <v-col align="left">
                <h2>Nyheder</h2>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="4" v-for="(n, i) in news" :key="i" align="left">
                <div>
                    <v-img :src="n.img" height="220" max-width="300"/>
                </div>
                <div class="display-1">{{ n.title }}</div>
                <div>{{ n.date }}</div>
                <div>{{ n.text }}</div>
            </v-col>
        </v-row>
        <v-divider/>
        <v-row>
            <v-col md="8" align="left">
                <h2>Har du spørgsmål?</h2>
                <ContactForm/>
            </v-col>
            <v-col md="4">
                <v-img :src="require('@/assets/GofiQR-iphone.png')"/>
            </v-col>
        </v-row>
        <v-divider/>
        <v-row>
            <v-col>
                <TryGofiqr/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ContactForm from "@/components/ContactForm";
    import TryGofiqr from "@/components/TryGofiqr";
    import FourSimpleSteps from "@/components/FourSimpleSteps";

    export default {
        name: "HomePage",
        components: {FourSimpleSteps, TryGofiqr, ContactForm},
        data: () => ({
            rotateImages: [
                {src: require('@/assets/gifiqr-vendlet-banner-forsiden.jpg')},
                {src: require('@/assets/gifiqr-JE-Juncker2.jpg')},
                {src: require('@/assets/gifiqr-JE-Juncker.jpg')},
            ],
            usages: [
                {
                    img: require('@/assets/GofiQR-produktinformation.png'),
                    title: 'Produktinformation',
                    text: 'Giv dine kunder let adgang til nyttige vejledninger på de produkter, du har solgt dem',
                    path: '/produktinformation',
                },
                {
                    img: require('@/assets/GofiQR-intern-vidensdeling.png'),
                    title: 'Intern vidensdeling',
                    text: 'Giv dine medarbejdere let adgang til vigtig viden om procedurer, arbejdsgange og nyheder i jeres fælles verden',
                    path: '/intern-vidensdeling',
                },
                {
                    img: require('@/assets/GofiQR-profilering.png'),
                    title: 'Profilering',
                    text: 'Giv dine besøgende let adgang til sjove oplevelser, aktiviteter og viden om jer – på alle sprog',
                    path: '/profilering',
                },
            ],
            news: [
                {
                    title: 'Cramo Adapteo er ny kunde på gofiqr',
                    img: require('@/assets/Cramo_Logo+289x289.png'),
                    date: '2017-03-17',
                    text: ''
                },
                {
                    title: 'Savner du overblik på hylderne?',
                    img: require('@/assets/samuel-zeller-118195.jpg'),
                    date: '2017-02-28',
                    text: 'Så er du ikke den eneste. I produktionsvirksomheden J E Juncker, som leverer ståldæksler og riste til kommuner og forsyningsselskaber, har vi hos gofiqr netop hjulpet organisationen i gang med en større forårsrengøring og givet dem redskabet til at identificere og registrere alle produkter i virksomhedens varelager.'
                },
                {
                    title: 'Flygtninge fortjener vel også lidt hjælp på vejen',
                    img: require('@/assets/david-siglin-87978.jpg'),
                    date: '2017-02-4',
                    text: 'Ingen tvivl om, at det er en god idé, at flygtninge og andre tilkomne borgere i Danmark lærer dansk, når de skal tilegne sig og bestride et job. Og ingen tvivl om, at det er noget af en mundfuld for langt de fleste og også ville være det for alle  os andre, hvis vi var i deres sted. Derfor har vi hos gofiqr valgt at undersøge, om vi ikke kan hjælpe "bjerget lidt tættere på Muhammed" - om man så må sige.'
                }
            ],
        }),
    }
</script>

